import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    body: {
        paddingTop: 45,
        paddingBottom: 100,
        paddingHorizontal: '1in',
        display: 'flex',
        // flexDirection: 'column'
        fontFamily: 'Times-Roman'
    },
    memoTitulo: {
        // textAlign: 'right',
        // marginLeft: 5,
        // marginTop: 10,
        // fontFamily: 'Times-Roman',
        // textAlign: 'center'
        // fontSize: 14
    },
    memoInfoRow: {
        display: 'flex',
        flexDirection: 'row',
        textAlign: 'left'
    },
    memoInfoValue: {
        // fontWeight: 'extrabold',
        fontSize: 12,
        fontFamily: 'Times-Roman',
        // fontWeight: '800',
        textTransform: 'capitalize',
        maxWidth: '80%'
    },
    memoInfo: {
        fontSize: 12,
        // marginLeft: 12,
        fontFamily: 'Times-Roman',
        width: 50
    },
    title: {
        fontSize: 24,
        textAlign: 'center',
        // fontFamily: 'Oswald'
    },
    author: {
        fontSize: 12,
        textAlign: 'center',
        marginBottom: 40,
    },
    subtitle: {
        fontSize: 18,
        margin: 12,
        // fontFamily: 'Oswald'
    },
    text: {
        // margin: 12,
        fontSize: 12,
        textAlign: 'justify',
        fontFamily: 'Times-Roman',
        zIndex: 800
    },
    image: {
        // marginVertical: 15,
        // marginHorizontal: 100,
        width: '100%',
        // height: 200
        marginBottom: 30
    },
    imageFooter: {
        // marginVertical: 15,
        // marginHorizontal: 100,
        bottom: 30,
        position: 'absolute',
        left: 70,
        right: 0,
        width: '100%',
        // height: 200
    },
    header: {
        marginBottom: 10,
        textAlign: 'center',
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 80,
        left: 0,
        right: '1.1in',
        textAlign: 'right',
        color: 'grey',
    },
    firmaContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        position: 'relative',
        width: '100%',
        marginTop: 0,
        flexWrap: 'wrap',
        // border: '1px solid #334422'
    },
    firmaItem: {
        width: '50%',
        // maxWidth: '50%',
        textAlign: 'center',
        // border: '1px solid #334422'
        // marginHorizontal: '3%'
    },
    imgFirma: {
        maxWidth: 250,
        height: 100,
        // border: '1px solid #ccc',
        margin: 'auto',
        zIndex: 100
    },
    firmaNombre: {
        fontSize: 12,
        fontFamily: 'Times-Roman',
        fontWeight: '800',
        textTransform: 'capitalize',
        textAlign: 'center',
        width: '100%'
    },
    marcaAguaContainer: {
        position: 'absolute',
        top: 300,
        left: 100,
    },
    marcaAgua: {
        fontSize: 120,
        color: '#CECECEBB',
        transform: 'rotate(45deg)',
        zIndex: 500,
        top: 0,
    },
    row: {
        display: 'flex',
        // width: '110%',
        // border: '1px solid #CCC',
        // height: 20,
        flexDirection: 'row',
        alignItems: 'center',
        borderTopWidth: 0,
        // marginLeft: '-5%'

    },
    rowTitle: {
        backgroundColor: '#7FC5F0',
        marginTop: 10
    },
    cell: {
        // height: 20,
        border: '1px solid #888',
        // width: '25%',
        padding: 5,
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderWidth: 0.6,
        backgroundColor: '#FFF'
    },
    cellVacio: {
        width: '120%', 
        padding: 5,
        marginLeft: '-5%', 
        marginRight: '-5%', 
        borderWidth: 0, 
        borderColor: '#FFF', 
        height: 20,
        backgroundColor: 'white',
    },
    cellText: {
        fontSize: 10,
        // textAlign: 'justify',
        fontFamily: 'Times-Roman',
        zIndex: 800,
    },
    cellTextTitle: {
        fontSize: 12,
        textAlign: 'center',
        fontFamily: 'Times-Roman',
        zIndex: 800,
        width: '100%',
        // color: 'white'
    },
    Titulo: {
        textAlign: 'center',
        marginBottom: 10
    },
    TransporteDia: {
        width: '110%',
        marginLeft: '-5%',
        border: '2px solid #7FC5F0',
        marginTop: 15,
        backgroundColor: '#7FC5F0',
    },
    AlimentacionDia: {
        width: '110%',
        marginLeft: '-5%',
        // border: '2px solid #7FC5F0',
        marginTop: 15,
        // backgroundColor: '#7FC5F0',
    },
    
    TransporteEncabezado: {
        backgroundColor: '#7FC5F0',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        Fecha: {
            fontSize: 12,
            textAlign: 'center',
            backgroundColor: '#7FC5F0',
        },
        Titulo: {
            fontSize: 10,
            padding: 2
        }
    },
});